<template>
    <div v-loading='loadingType' class="universityRankList">
        <div class="position-relative margin-top"  >
            <div v-show="rankSm!==''&&!loadingType">
                <div class="commonBackground padding-x-y">
                    <span class="font-weight-bold margin-right">院校类型:</span>
                    <el-button size="mini" class="margin-left"
                               :class="getSelectTypeId===item.index?'directoryActive':''"
                               @click="selectType(item.index)" v-for="item in univerSityType" :key="item.index">
                        {{item.value}}
                    </el-button>
                </div>
            </div>

        </div>
        <div class="commonBackground">
            <div class="margin-y" v-show="rankSm!==''&&!loadingType">
                <div class="padding-y text-center text-m-size font-weight-bold">
                    {{title}}
                </div>
                <div class="text-center text-l-secondary">
                    说明：{{rankSm}}
                </div>
            </div>
            <common-table @handlerPage="handlerPage"
                          :tableData="uniDataList"
                          :headerCellStyle="headerCellStyle"
                          :loading="loadingData"
                          :pageObj="pageObj"
                          :fieldList="fieldList">
            </common-table>
        </div>
    </div>
</template>
<script>
    import {uniRankInfo, uniRankList, uniRankTypes} from "../../../config";
    export default {
        name: "universityRankList",
        data(){
            return{
                pageObj:{
                    size:40,
                    total:0,
                    currentPage:1,
                    func:'func'
                },
                headerCellStyle:{
                    background: '#e8ffe9',
                    color: '#666666',
                    fontWeight: 'bolder',
                    textAlign: 'center',
                },
                getSelectTypeId:'',
                fieldList:[],
                loadingType:false,
                loadingData:false,
                //说明
                rankSm:'',
                //表格头部
                rankTableTitle:[],
                //查出院校类型
                univerSityType:[],
                //查看当前院校基本信息
                title:'',
                //查看当前院校列表详情
                uniDataList:[],
                currentPage:1,
            }
        },
        mounted(){
            this.searchUniverSityType();
        },
        methods:{
            handlerPage(val){
                this.pageObj.currentPage=val;
                this.currentPage=val;
                this.univerRankList();
            },
            //选择院校类型
            selectType(val){
                this.getSelectTypeId=val;
                this.pageObj.currentPage=1;
                this.currentPage=1;
                //查出当前排行榜信息
                this.univerRankInfo();
                //查出排行榜数据列表
                this.univerRankList();
            },
            //查出院校类型
            async searchUniverSityType(){
                this.loadingType=true;
                let result=await uniRankTypes();
                if(result.status){
                    this.getSelectTypeId=result.data[0].index;
                    this.loadingType=false;
                    this.univerSityType=result.data;
                    //查出当前排行榜信息
                    this.univerRankInfo();
                    //查出排行榜数据列表
                    this.univerRankList();
                    console.log(result.data);
                }else{
                    this.loadingType=false;
                }
            },
            //查出排行榜基本信息
            async univerRankInfo(){
                this.loadingType=true;
                this.rankSm='';
                let result=await uniRankInfo(this.getSelectTypeId);
                if(result.status){
                    this.loadingType=false;
                    this.fieldList=[];
                    this.rankSm=result.data.description;
                    this.rankTableTitle=result.data.tableHeader;
                    let zhi=['rankIdx','universityName','universityTypeName','provinceName',
                    'levelName','rankScore'];
                    // 排名"
                    // 1: "学校名称"
                    // 2: "类型"
                    // 3: "所在地"
                    // 4: "学历层次"
                    // 5: "综合得分"
                    result.data.tableHeader.forEach((val,index)=>{
                        this.fieldList.push({
                            label:val,prop:zhi[index]
                        })
                    });
                    this.title=result.data.title;
                }else{
                    this.loadingType=false;
                }
            },

            //查出排行榜数据列表

            async univerRankList(){
                this.loadingData=true;
                let result=await uniRankList(this.getSelectTypeId,this.currentPage,40);
                if(result.status){
                    this.loadingData=false;
                    console.log('我是数据列表');
                    console.log(result.data);
                    this.uniDataList=result.data.data;
                    this.pageObj.total=result.data.totalRecords;
                }else{
                    this.loadingData=false;
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    .universityRankList{
        min-height:700px;
    }
</style>
